export interface IHipConfig {
    error?: number;
    left?: number;

    // ---------------------------------------------------------------------
    // Toggle to display instruction in frame or inside input box.
    // ---------------------------------------------------------------------
    showInstruction: boolean;

    showMenu: boolean;
    getMenu?: () => { 'refresh': any, 'proofType': any }; // return a json object  { 'refresh': item1, 'proofType': item2};//internal use.

    // -----------------------------------------------------------------------
    // For display Hip menu in your designed place.
    // Remove this line it if you have no this requirement.
    // -----------------------------------------------------------------------
    // menuOutsideCallback: function (menu) { refreshOutsideMenu(menu) }, //<----------------------add menu as parameter

    showError?: boolean; // <--------------------------- use showError for oppsite meaning

    // -----------------------------------------------------------------------
    // For display Hip Error in your designed place.
    // Remove this line it if you have no this requirement.
    // -----------------------------------------------------------------------
    // showErrorCallback: function (message) { var ele = document.getElementById('idError'); ele.innerHTML = message; };

    // -----------------------------------------------------------------------
    // Remove Hip Error in your designed place.
    // Remove this line it if you have no this requirement.
    // -----------------------------------------------------------------------
    // removeErrorCallback: function () { var ele = document.getElementById('idError'); ele.innerHTML = ""; };

    instructionsInside: boolean;

    inputWidth?: number;
    done?: boolean;

    // --------------------------------------------------------------------------------------------------------
    // holder element id.
    // Search ispHIPHIP in this page for where it is.
    // use your own name in your page and make sure that no conflicts to your other element id.
    // ---------------------------------------------------------------------------------------------------------
    holder: string;

    // --------------------------------------------------------------------------------------------------------
    // holder element id.
    // Search ispHIPHIP in this page for where it is.
    // use your own name in your page and make sure that no conflicts to your other element id.
    // ---------------------------------------------------------------------------------------------------------
    scriptHolder: string;
    count?: number;
    type: 'visual' | 'audio';
    market: string; // locale

    cssSet: {
        cssCdHIPMenu: string;
        cssCdHIPInput: string;
        cssCdHIPLink: string;
        cssCdHIPError: string;
        cssCdHIPErrorImg: string;
    };

    postLoad: () => void;
}

export interface IHipObject extends IHipConfig {
    // -----------------------------------------------------------------------
    // For display Hip instruction in your designed place.
    // Remove this line it if you have no this requirement.
    // -----------------------------------------------------------------------
    // instructionOutsideCallback: function (instruction) { instructionCallback(instruction) },
    // <---------------add instruction as parameter, and remove the expose get instruction from API.
    getInstruction: () => string; // implement internal.
    getError: () => string;
    getSolution: () => string;
    reloadHIP: () => void;
    switchHIP: (a: any, b: any, c: any) => any; // Don't know the interface, feel free to reverse engineer if needed
    clientValidation: () => void;
    setError: () => string;
    setFocus: () => string;

    verify: (_callback: (solution: string, token: string, hip: IHipObject) => void, _hip: IHipObject) => {};
}

export const hipConfig: IHipConfig = {
    showInstruction: true,
    showMenu: true,
    instructionsInside: true,
    holder: 'captchaImage',
    scriptHolder: 'captchaScript',
    type: 'visual',
    market: 'en-us',

    cssSet: {
        cssCdHIPMenu: 'menu',
        cssCdHIPInput: 'solution',
        cssCdHIPLink: 'link',
        cssCdHIPError: 'error',
        cssCdHIPErrorImg: 'imageError',
    },
    // tslint:disable-next-line:no-empty
    postLoad: () => { },
};
